import { defineStore } from "pinia";
import { ref } from "vue";
import { computed } from "vue";

export const useErrorsStore = defineStore("errors", () => {

  const errors = ref([]);

  const hasFatalErrors = computed(() => {
    return errors.value.some(error => error.severity === 'fatal');
  });

  const hasCriticalErrors = computed(() => {
    return errors.value.some(error => error.severity === 'critical');
  });

  const pushError = function (error) {
    errors.value.push(error);
  }

  const pushErrorCode = function (errorCode, severity) {
    const error = {
      severity: severity,
      message: errorMap[errorCode] ?? errorMap['unknown-cause']
    }
    pushError(error)
  }

  const resetStore = function () {
    errors.value = [];
  }

  const errorMap = {
    'entity-used': 'Record non eliminabile',
    'entity-exists': 'Record già esistente',
    'user-not-found': 'Utente non trovato',
    'user-exists': 'Utente già utilizzato',
    'role-invalid': 'Ruolo non valido',
    'affiliate-not-found': 'Affiliato non trovato',
    'bottler-not-found': 'Imbottigliatore non trovato',
    'company-not-found': 'Azienda non trovata',
    'selection-site-not-found': 'Centro di selezione non trovato',
    'category-not-found': 'Categoria non trovata',
    'product-not-found': 'Prodotto non trovato',
    'auction-not-found': 'Asta non trovata',
    'auction-not-updatable': 'Asta non modificabile',
    'auction-invalid-dates': 'Date dell\'asta non valide',
    'auction-invalid-redistributable': 'Configurazione redistribuzione non valida',
    'auction-invalid-qmg': 'Configurazione QMG non valida',
    'auction-empty': 'L\'asta non contiene lotti',
    'lot-not-found': 'Lotto non trovato',
    'lot-code-exists': 'Codice lotto già esistente',
    'lot-redistribute-not-found': 'Lotto redistribuzione non trovato',
    'lot-not-accessible': 'Lotto non accessibile',
    'other-offer-received': 'Un\'altra offerta è stata ricevuta, riprova',
    'invalid-multiplier': 'Moltiplicatore non valido',
    'waste-code-not-found': 'Codice rifiuto non trovato',
    'warehouse-not-found': 'Magazzino non trovato',
    'auction-attachment-not-found': 'Allegato non trovato',
    'attachment-upload-failed': 'Caricamento allegato fallito',
    'attachment-upload-too-big': 'Allegato troppo grande',
    'company-group-not-found': 'Gruppo aziendale non trovato',
    'auction-calendar-entry-not-found': 'Evento calendario non trovato',
    'access-denied': 'Accesso negato',
    'auth0-error': 'Errore di autenticazione',
    'invalid-payload': 'Payload invalido',
    'timeout-error': 'Tempo scaduto, riprova',
    'unknown-cause': 'Errore sconosciuto'
  }

  return { errors, pushError, pushErrorCode, resetStore, hasFatalErrors, hasCriticalErrors };
});
